// Towing electrics package deals — package prices set by the workshop; savings = sum of individual prices − package price
export const TOWING_PROMO = {
  slug: "towing-deals",
  path: "/towing-deals",
  eyebrow: "CARAVAN SEASON",
  name: "Tow Ready Packages",
  barText: "TOW READY PACKAGES FROM $1,250 — SAVE UP TO $180 on Tow-Pro + Anderson + 12 pin. One workshop day, trailer-tested.",
  barCta: "SEE THE PACKAGES",
  sub: "REDARC Tow-Pro Elite brake controller, grey Anderson plug and standard 12 pin trailer plug — fitted together at our Kunda Park workshop, tested on a trailer, and backed by our 12-month workmanship warranty. The more you bundle, the more you save.",
  serviceSlugs: [
    "redarc-brake-controllers",
    "12-pin-trailer-plug-install",
    "anderson-plug-installation-sunshine-coast",
    "towing-electrics-sunshine-coast",
    "caravan-tow-vehicle-electrical-sunshine-coast",
  ],
  // Individual (normal) prices — GST inc
  parts: {
    towpro: { basic: 805, smart: 855, nextgen: 1080.38 },
    anderson: 495,
    andersonRelay: 550,
    twelvePin: 495,
    twelvePinSensor: 530,
  },
  tiers: [
    { key: "basic", label: "Basic Tow-Pro", short: "Basic", vehicles: "Vehicles with a standard analogue brake-light signal" },
    { key: "smart", label: "Smart (CAN-bus) Tow-Pro", short: "Smart", vehicles: "LandCruiser 300 & 200, Hilux, D-MAX, Prado, Everest (pre next-gen), Patrol, most late-model utes" },
    { key: "nextgen", label: "Next-Gen Ranger / Everest & Amarok", short: "Next-Gen", vehicles: "Needs a dedicated vehicle-specific REDARC kit — that's why the Tow-Pro price is higher (set price)" },
  ],
  // Package prices per tier (Basic = Smart − $50). nextgen null = quoted on request.
  packages: [
    { key: "tp-and", name: "Tow-Pro + Anderson", includes: ["REDARC Tow-Pro Elite", "Grey Anderson plug (no relay)"], parts: ["towpro", "anderson"], price: { basic: 1250, smart: 1300, nextgen: 1530.38 } },
    { key: "tp-andr", name: "Tow-Pro + Anderson with Ignition Relay", includes: ["REDARC Tow-Pro Elite", "Grey Anderson plug with ignition relay (lithium / DC-DC vans)"], parts: ["towpro", "andersonRelay"], price: { basic: 1305, smart: 1355, nextgen: 1580.38 } },
    { key: "tp-and-12", name: "Tow-Pro + Anderson + 12 Pin", includes: ["REDARC Tow-Pro Elite", "Grey Anderson plug (no relay)", "Standard 12 pin plug with relay"], parts: ["towpro", "anderson", "twelvePin"], price: { basic: 1650, smart: 1700, nextgen: 1900 }, popular: true },
    { key: "tp-andr-12", name: "Tow-Pro + Anderson with Ignition Relay + 12 Pin", includes: ["REDARC Tow-Pro Elite", "Grey Anderson plug with ignition relay", "Standard 12 pin plug with relay"], parts: ["towpro", "andersonRelay", "twelvePin"], price: { basic: 1695, smart: 1745, nextgen: 1945 } },
    { key: "tp-and-12s", name: "Tow-Pro + Anderson + 12 Pin with Reverse Sensor Switch", includes: ["REDARC Tow-Pro Elite", "Grey Anderson plug (no relay)", "12 pin plug with relay + reverse-sensor disable"], parts: ["towpro", "anderson", "twelvePinSensor"], price: { basic: 1720, smart: 1770, nextgen: null } },
  ],
  disclaimer:
    "All package prices are 'from' prices, GST inc, for supply and install at our Kunda Park workshop, confirmed in writing before booking. Savings are measured against our individual service prices. 12 pin prices are for a standard 12 pin plug only — extra pins or circuits are quoted separately. A current caravan / trailer wiring diagram is required before any 12 pin or Anderson plug booking. Next-Gen Ranger / Everest & Amarok Tow-Pro is a set price due to the dedicated kit required.",
};

const partPrice = (part, tier) => (part === "towpro" ? TOWING_PROMO.parts.towpro[tier] : TOWING_PROMO.parts[part]);
const r2 = (n) => Math.round(n * 100) / 100;

export const normalPrice = (pkg, tier) => r2(pkg.parts.reduce((s, p) => s + partPrice(p, tier), 0));
export const packagePrice = (pkg, tier) => pkg.price[tier];
export const saving = (pkg, tier) => (pkg.price[tier] == null ? null : r2(normalPrice(pkg, tier) - pkg.price[tier]));

export const lowestPackagePrice = () =>
  Math.min(...TOWING_PROMO.packages.flatMap((p) => Object.values(p.price).filter((v) => v != null)));
export const maxSaving = () =>
  Math.max(...TOWING_PROMO.packages.flatMap((p) => TOWING_PROMO.tiers.map((t) => saving(p, t.key) ?? 0)));

export const money = (n) =>
  Number.isInteger(n) ? `$${n.toLocaleString("en-AU")}` : `$${n.toLocaleString("en-AU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
